import { useMutation } from '@tanstack/react-query';
import { OrganizationDto } from 'models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { useSelectedOrganization } from './useSelectedOrganization';

export const useUpdateOrganizationBaseUrl = (organizationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const { selectedOrganization, setSelectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationKey: ['updateOrganizationBaseUrl', organizationId],
        mutationFn: (body: { baseUrl: string }) => apiClient.fetchApi<OrganizationDto, { baseUrl: string }>({ method: 'POST', endpoint: `organizations/${organizationId}/base-url`, body }),
        onSuccess: (data) => {
            onSuccess();
            if (data.id === selectedOrganization?.id) {
                setSelectedOrganization(data);
            }
        },
    });
};
